<template>
	<colorPick
		theme="light"
		:color="defaultColor"
		:sucker-hide="true"
		:sucker-canvas="suckerCanvas"
		:sucker-area="suckerArea"
		@changeColor="changeColor"
		@openSucker="openSucker"
	/>
</template>

<script>
import colorPick from '@caohenghu/vue-colorpicker';
export default {
	name: 'colorPicker',
	components: { colorPick },
	props: {
		defaultColor: { required: false, type: String },
	},
	data() {
		return {
			color: '',
			suckerCanvas: null,
			suckerArea: [],
			isSucking: false,
		};
	},
	computed: {
		selectedColor: {
			get() {
				return this.color || this.defaultColor;
			},
			set(value) {
				// debugger;
				this.color = value;
			},
		},
	},
	methods: {
		changeColor(color) {
			const { r, g, b, a } = color.rgba;
			this.color = `rgba(${r}, ${g}, ${b}, ${a})`;
			this.$emit('colorChange', color.hex);
		},
		handleClose(valueColor) {
			this.$emit('colorChange', valueColor);
		},
		openSucker(isOpen) {
			if (isOpen) {
				// ... canvas be created
				// this.suckerCanvas = canvas
				// this.suckerArea = [x1, y1, x2, y2]
			} else {
				// this.suckerCanvas && this.suckerCanvas.remove
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.hu-color-picker {
	width: 218px !important;
}
</style>
